<form [formGroup]="searchAddressForm">
  <div class="row">
    <div class="col-6 col-md-4">
      <mat-form-field class="small-form-field">
        <mat-label>Street Number</mat-label>
        <input matInput formControlName="streetNumber" />
      </mat-form-field>
    </div>

    <div class="col-6 col-md-4">
      <mat-form-field class="small-form-field">
        <mat-label>Street Name</mat-label>
        <input matInput formControlName="streetName" />
      </mat-form-field>
    </div>

    <div class="col-6 col-md-4">
      <mat-form-field class="small-form-field">
        <mat-label>Unit Number</mat-label>
        <input matInput formControlName="unitNumber" />
      </mat-form-field>
    </div>

    <div class="col-6 col-md-4">
      <mat-form-field class="small-form-field">
        <mat-label>City</mat-label>
        <input matInput formControlName="city" />
      </mat-form-field>
    </div>

    <div class="col-6 col-md-4">
      <mat-form-field class="small-form-field">
        <mat-label>State</mat-label>
        <mat-select formControlName="state">
          <mat-option *ngFor="let state of constant.STATES | keyvalue" [value]="state.key">
            {{ $any(state).value | titlecase }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="col-6 col-md-4">
      <mat-form-field class="small-form-field">
        <mat-label>Zip</mat-label>

        <input matInput formControlName="zip" />
        <!-- (keyup)="applyFilter($any($event.target).value)" placeholder="Search Name, Type" -->
      </mat-form-field>
    </div>

    <div class="col-12 col-md-6 col-sm-12">
      <button mat-flat-button color="primary" class="primary mr-2" (click)="addressSearch()">Search</button>
      <button mat-stroked-button class="primary" (click)="resetSearchFilter()">Reset</button>
    </div>
  </div>
</form>
